module.exports = __webpack_public_path__ + "static/media/route_path_direction_Selected.4b5bef28.svg";